import setCursorNext from "./setCursorNext";
import setCursorPrevious from "./setCursorPrevious";

export const navigateNext = () => (dispatch, getState) => {
  const state = getState();

  const { blocks, questions, payload, cursor } = state;
  dispatch(
    setCursorNext(blocks, questions, payload, cursor.path[cursor.index], getState)
  );

  window.scrollTo(0, 0);
};

export const navigatePrevious = () => (dispatch, getState) => {
  const state = getState();

  const { blocks, questions, payload, cursor } = state;
  dispatch(
    setCursorPrevious(blocks, questions, payload, cursor.path[cursor.index], getState)
  );

  window.scrollTo(0, 0);
};
